import { fabric } from "fabric";
import DEFINE from "./define";

import Eraser from "./tools/eraser";
import Compass from "./tools/compass";
import Free from "./tools/free";
import Arrow from "./tools/arrow";
import StraightLine from "./tools/straight_line";
import HorizonLine from "./tools/horizon_line";
import DottedLine from "./tools/dotted_line";
import VerticalLine from "./tools/vertical_line";
import HollowOut from "./tools/hollow_out";
import LineFullUp from "./tools/line_full_up";
import ShapeFullUp from "./tools/shape_full_up";
import Circle from "./tools/circle";
import Polygon from "./tools/polygon";
import Triangle from "./tools/triangle";
import Retangle from "./tools/retangle";
import Star from "./tools/star";
import Protractor from "./tools/protractor";
import Ruler from "./tools/ruler";
import IsoscelesTriangle from "./tools/isosceles_triangle";
import RightTriangle from "./tools/right_triangle";
import AngleTool from "./tools/angle_tool";
import PolygonTool from "./tools/polygon_tool";
import TriangleTool from "./tools/triangle_tool";
import InsertWebLink from "./tools/insert_web_link";
import InsertPicture from "./tools/insert_picture";
import PeelableSticker from "./tools/peelable_sticker";
import Sticky from "./tools/sticky";
import TextBox from "./tools/textBox";
import Stamp from "./tools/stamp";
import GraphicBoard from "./tools/graphic_board";
import EventBus from "../event_bus";
import FreeLaser from "./tools/free_laser";

export default class painter {

    // PainterProxy
    proxy = null;

    // 目標canvas
    canvas = null;
    canvasId = "";

    initialCanvasSize = { width: 0, height: 0 };
    currentCanvasSize = { width: 0, height: 0 };

    // 視野範圍與偏移量
    viewportTransform = { x: 0, y: 0, scale: 1 };

    // 物件操作紀錄
    history = new Array();
    tempHistory = new Array();

    // 清除全部排除對象
    exceptClearTarget = [
        DEFINE.TOOLS.COMPASS,
        DEFINE.TOOLS.PROTRACTOR,
        DEFINE.TOOLS.RULER,
        DEFINE.TOOLS.ISOSCELES_TRIANGLE,
        DEFINE.TOOLS.RIGHT_TRIANGLE,

    ];

    exceptClearTargetAtAllClear = [
        DEFINE.TOOLS.INSERT_PICTURE,
        DEFINE.TOOLS.INSERT_WEB_LINK,
        DEFINE.TOOLS.TEXT_BOX,
        DEFINE.TOOLS.STICKY,
        DEFINE.TOOLS.PEELABLE_STICKER,
        DEFINE.TOOLS.GRAPHIC_BOARD
    ];

    recordIgnoreList = [
        DEFINE.TOOLS.COMPASS,
        DEFINE.TOOLS.PROTRACTOR,
        DEFINE.TOOLS.RULER,
        DEFINE.TOOLS.ISOSCELES_TRIANGLE,
        DEFINE.TOOLS.RIGHT_TRIANGLE,
        DEFINE.TOOLS.FREE_LASER
    ];
    exceptTools = [
        DEFINE.TOOLS.STICKY,
        DEFINE.TOOLS.TEXT_BOX,
        DEFINE.TOOLS.INSERT_PICTURE,
        DEFINE.TOOLS.INSERT_WEB_LINK,
        DEFINE.TOOLS.PEELABLE_STICKER,
        DEFINE.TOOLS.STAMP,
    ];

    toolMap = new Map();

    currentTool = null;

    isObjectMoving = false;

    isInteractive = true;

    onFinishLoadSave = null;

    constructor(proxy, canvasId) {
        this.proxy = proxy;
        this.canvasId = canvasId;

        if (document.getElementById(canvasId)) {
            this.canvas = new fabric.Canvas(canvasId, {
                selection: false,
                isDrawingMode: false,
                preserveObjectStacking: true
            });

            this.setInitialCanvasSize(this.canvas.width, this.canvas.height);

            this.registerTool();
            this.registerEvent();

            this.addHistory();
        } else {
            throw `can not found canvasId: ${canvasId}`;
        }
    }

    getCanvas() {
        return this.canvas;
    }

    /**
     * 初始canvas尺寸
     * @param {Number} width 
     * @param {Number} height 
     */
    setInitialCanvasSize(width, height) {
        this.initialCanvasSize = { width, height };
        this.currentCanvasSize = { width, height };
    }

    /**
     * 重新設定canvas尺寸
     * @param {Number} width 
     * @param {Number} height 
     */
    setPainterSize(width, height) {
        this.currentCanvasSize = { width, height };
        this.canvas.setWidth(width);
        this.canvas.setHeight(height);
        this.canvas.renderAll();
    }

    /**
     * 刷新視野範圍
     */
    updateViewportTransform(x, y, scale) {
        let originX = this.viewportTransform.x;
        let originY = this.viewportTransform.y;
        let originScale = this.viewportTransform.scale;

        this.viewportTransform = {
            x: (x == null) ? this.viewportTransform.x : x,
            y: (y == null) ? this.viewportTransform.y : y,
            scale: (scale == null) ? this.viewportTransform.scale : scale,
        }
        this.canvas.setViewportTransform([
            this.currentCanvasSize.width / this.initialCanvasSize.width * this.viewportTransform.scale,
            0,
            0,
            this.currentCanvasSize.height / this.initialCanvasSize.height * this.viewportTransform.scale,
            this.viewportTransform.x,
            this.viewportTransform.y
        ]);

        this.toolMap.get(DEFINE.TOOLS.COMPASS).scaling(originX, originY, originScale);

        this.canvas.requestRenderAll();
    }

    /**
     * 取得畫筆設定
     * @param {DEFINE.DRAW_TYPE} drawType
     * @returns setting
     */
    getDrawSetting(drawType) {
        const painterProxy = this.proxy;

        let operate = painterProxy.getOperate();

        let fill = "rgba(0, 0, 0, 1)";
        let stroke = "rgba(0, 0, 0, 1)";
        let strokeWidth = 2.5;
        switch (operate) {
            case DEFINE.OPERATE.PEN:
            case DEFINE.OPERATE.SELECTION:
                fill = (drawType == DEFINE.DRAW_TYPE.LINE_SEGMENT || !painterProxy.getHollow(DEFINE.OPERATE.PEN))
                    ? painterProxy.getColor(DEFINE.OPERATE.PEN)
                    : DEFINE.COLOR.TRANSPARENT;
                stroke = painterProxy.getColor(DEFINE.OPERATE.PEN);
                strokeWidth = painterProxy.getWidth(DEFINE.OPERATE.PEN);
                break;
            case DEFINE.OPERATE.HIGHLIGHTER:
                fill = (drawType == DEFINE.DRAW_TYPE.LINE_SEGMENT || !painterProxy.getHollow(DEFINE.OPERATE.HIGHLIGHTER))
                    ? painterProxy.getColor(DEFINE.OPERATE.HIGHLIGHTER)
                    : DEFINE.COLOR.TRANSPARENT;
                stroke = painterProxy.getColor(DEFINE.OPERATE.HIGHLIGHTER);
                strokeWidth = painterProxy.getWidth(DEFINE.OPERATE.HIGHLIGHTER);
                break;
            case DEFINE.OPERATE.LASER_POINTER:
                fill = painterProxy.getColor(DEFINE.OPERATE.LASER_POINTER);
                stroke = painterProxy.getColor(DEFINE.OPERATE.LASER_POINTER);
                strokeWidth = painterProxy.getWidth(DEFINE.OPERATE.LASER_POINTER);
                break;
            case DEFINE.OPERATE.ERASER:
                break;
            default:
                throw `TypeError: getDrawSetting type(${operate}) is not define.`
        }

        return {
            fill: fill,
            stroke: stroke,
            strokeWidth: strokeWidth,
            opacity: (operate == DEFINE.OPERATE.HIGHLIGHTER) ? 0.5 : 1
        };
    }

    /**
     * 取得畫筆顏色
     * @returns String
     */
    getDrawColor() {
        const painterProxy = this.proxy;

        let operate = painterProxy.getOperate();

        let fill = "rgba(0, 0, 0, 1)";
        switch (operate) {
            case DEFINE.OPERATE.PEN:
                fill = painterProxy.getColor(DEFINE.OPERATE.PEN);
                break;
            case DEFINE.OPERATE.HIGHLIGHTER:
                fill = painterProxy.getColor(DEFINE.OPERATE.HIGHLIGHTER);
                break;
            case DEFINE.OPERATE.LASER_POINTER:
                fill = painterProxy.getColor(DEFINE.OPERATE.LASER_POINTER);
                break;
            default:
                throw `TypeError: getDrawColor type(${operate}) is not define.`
        }

        return {
            fill: fill,
        };
    }

    /**
     * 註冊工具
     */
    registerTool() {
        // 線段
        this.toolMap.set(DEFINE.TOOLS.FREE, new Free(this));
        this.toolMap.set(DEFINE.TOOLS.FREE_LASER, new FreeLaser(this));
        this.toolMap.set(DEFINE.TOOLS.STRAIGHT_LINE, new StraightLine(this));
        this.toolMap.set(DEFINE.TOOLS.HORIZON_LINE, new HorizonLine(this));
        this.toolMap.set(DEFINE.TOOLS.VERTICAL_LINE, new VerticalLine(this));
        this.toolMap.set(DEFINE.TOOLS.DOTTED_LINE, new DottedLine(this));
        this.toolMap.set(DEFINE.TOOLS.ARROW, new Arrow(this));
        // 圖形
        this.toolMap.set(DEFINE.TOOLS.CIRCLE, new Circle(this));
        this.toolMap.set(DEFINE.TOOLS.RETANGLE, new Retangle(this));
        this.toolMap.set(DEFINE.TOOLS.TRIANGLE, new Triangle(this));
        this.toolMap.set(DEFINE.TOOLS.POLYGON, new Polygon(this));
        this.toolMap.set(DEFINE.TOOLS.STAR, new Star(this));
        // 畫圖工具
        this.toolMap.set(DEFINE.TOOLS.SHAPE_FULL_UP, new ShapeFullUp(this));
        this.toolMap.set(DEFINE.TOOLS.LINE_FULL_UP, new LineFullUp(this));
        this.toolMap.set(DEFINE.TOOLS.HOLLOW_OUT, new HollowOut(this));
        // 橡皮擦
        this.toolMap.set(DEFINE.TOOLS.ERASER, new Eraser(this));
        // 數學工具
        this.toolMap.set(DEFINE.TOOLS.COMPASS, new Compass(this));
        this.toolMap.set(DEFINE.TOOLS.PROTRACTOR, new Protractor(this));
        this.toolMap.set(DEFINE.TOOLS.RULER, new Ruler(this));
        this.toolMap.set(DEFINE.TOOLS.ISOSCELES_TRIANGLE, new IsoscelesTriangle(this));
        this.toolMap.set(DEFINE.TOOLS.RIGHT_TRIANGLE, new RightTriangle(this));
        this.toolMap.set(DEFINE.TOOLS.ANGLE_TOOL, new AngleTool(this));
        this.toolMap.set(DEFINE.TOOLS.POLYGON_TOOL, new PolygonTool(this));
        this.toolMap.set(DEFINE.TOOLS.TRIANGLE_TOOL, new TriangleTool(this));
        //其他工具
        this.toolMap.set(DEFINE.TOOLS.INSERT_WEB_LINK, new InsertWebLink(this));
        this.toolMap.set(DEFINE.TOOLS.INSERT_PICTURE, new InsertPicture(this));
        this.toolMap.set(DEFINE.TOOLS.PEELABLE_STICKER, new PeelableSticker(this));
        this.toolMap.set(DEFINE.TOOLS.STICKY, new Sticky(this));
        this.toolMap.set(DEFINE.TOOLS.TEXT_BOX, new TextBox(this));
        this.toolMap.set(DEFINE.TOOLS.STAMP, new Stamp(this));
        this.toolMap.set(DEFINE.TOOLS.GRAPHIC_BOARD, new GraphicBoard(this));
    }

    /**
     * 註冊事件
     */
    registerEvent() {
        const self = this;

        this.canvas.on("object:added", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                self.updateZorder();
                if (this.currentTool && !this.isLoading) this.currentTool.objectAdded(o);
            }
        });

        this.canvas.on("object:moving", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                this.isObjectMoving = true;
            }
        })

        this.canvas.on("mouse:down:before", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                if (o.target) {
                    if (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION) {
                        this.canvas.isDrawingMode = false;
                        if (o.target.selectionActive) {
                            this.currentTool = this.toolMap.get(o.target.toolType);
                        }
                    }
                } else {
                    if (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION) {
                        this.canvas.isDrawingMode = false;
                    }

                    if (this.proxy.getPenClick() || this.proxy.getOperate() == DEFINE.OPERATE.SELECTION) {
                        EventBus.getInstance().emit('mouse:down:before', o);
                    }
                }

                if (this.currentTool) this.currentTool.mouseDownBefore(o);
            }
        });

        this.canvas.on("mouse:down", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                EventBus.getInstance().emit('click:object', o);

                if (o.target && !this.proxy.getPenClick()) {
                    if (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION) {
                        if (o.target.selectionActive) {
                            console.log("trigger current tool");
                            this.currentTool = this.toolMap.get(o.target.toolType);
                        }
                    }
                } else {
                    if (this.proxy.getPenClick() || (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION)) {
                        if (!this.exceptTools.includes(this.proxy.currentToolName)) {
                            console.log("trigger button");
                            EventBus.getInstance().emit('mouse:down', o);
                            // this.mousedownTimer = setTimeout(() => {
                            //     this.mousedownTimer = null;
                            // }, 100);
                        }
                    }
                }

                if (this.currentTool && this.isInteractive) this.currentTool.mouseDown(o);
            }
        });

        this.canvas.on("mouse:move", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                if (this.mousedownTimer) {
                    EventBus.getInstance().pointerdown = true;
                    clearTimeout(this.mousedownTimer);
                    this.mousedownTimer = null;
                }
                if (o.target) {

                } else {
                    if (this.proxy.getPenClick() || (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION)) {
                        EventBus.getInstance().emit('mouse:move', o);
                    }
                }

                if (this.currentTool) this.currentTool.mouseMove(o);
            }
        });

        this.canvas.on("mouse:up", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                if (o.target) {
                    if (this.isObjectMoving) {
                        this.addHistory();
                    }
                }
                if (this.proxy.getPenClick() || (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION)) {
                    // if(this.mousedownTimer) {
                    //     clearTimeout(this.mousedownTimer);
                    //     EventBus.getInstance().emit('mouse:down', o);    
                    // }
                    EventBus.getInstance().emit('mouse:up', o);
                }

                if (this.currentTool) this.currentTool.mouseUp(o);
                this.isObjectMoving = false;
            }
        });

        this.canvas.on("mouse:dblclick", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                if (o.target) {

                } else {
                    if (this.proxy.getPenClick() || (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION)) {
                        EventBus.getInstance().emit('mouse:dblclick', o);
                    }
                }

                if (this.currentTool) this.currentTool.mouseDBLClick(o);
            }
        });

        this.canvas.on("mouse:wheel", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                if (o.target) {

                } else {
                    if (this.proxy.getPenClick() || (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION)) {
                        EventBus.getInstance().emit('mouse:wheel', o);
                    }
                }

                if (this.currentTool) this.currentTool.mouseWheel(o);
            }
        })

        this.canvas.on("mouse:over", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                if (o.target) {
                    if (o.target.toolType) {
                        this.toolMap.get(o.target.toolType).mouseOver(o);
                    }
                } else {
                    if (this.proxy.getPenClick() || (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION)) {
                        EventBus.getInstance().emit('mouse:over', o);
                    }
                }
            }
        })

        this.canvas.on("mouse:out", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                if (o.target) {
                    if (o.target.toolType) {
                        this.toolMap.get(o.target.toolType).mouseOut(o);
                    }
                } else {
                    if (this.proxy.getPenClick() || (this.proxy.getOperate() == DEFINE.OPERATE.SELECTION)) {
                        EventBus.getInstance().emit('mouse:out', o);
                    }
                }
            }
        })

        this.canvas.on("selection:created", (o) => {
            if (this.proxy.getCurrentPainter().painter == this) {
                if (!this.currentTool) return;

                if (this.currentTool) this.currentTool.selectionCreated(o);

                if (o.selected[0]) {
                    self.canvas.discardActiveObject(o.selected[0]);
                }
            }
        })
    }

    recoverEvent(object) {
        let tool = this.toolMap.get(object.toolType);
        tool.recover(object);
    }

    changeTool(toolName, args) {
        let newTool = this.toolMap.get(toolName);

        if (!newTool) {
            this.currentTool = null;
            return;
        }

        if (this.currentTool == newTool) return;

        this.currentTool = newTool;
        this.currentTool.setValue(args);
        this.currentTool.create();
    }

    getCursor() {
        return this.canvas.upperCanvasEl.style.cursor;
    }

    /**
     * 更改鼠標
     * @param {string} cursor 
     */
    changeCursor(cursor) {
        if (this.getCursor() == cursor) return;

        this.canvas.defaultCursor = cursor;
        this.canvas.hoverCursor = cursor;
        this.canvas.moveCursor = cursor;
        this.canvas.freeDrawingCursor = cursor;
        this.canvas.notAllowedCursor = cursor;
        this.canvas.containerClass = cursor;
        this.canvas.setCursor(cursor);
    }

    disableAllObject(isDisable) {
        this.getObjects("").forEach(object => {
            object.evented = isDisable;
        })
    }

    /**
     * 全部清除
     */
    clearAll(isExcept, isClearPage) {
        let objects = this.canvas.getObjects();

        for (let i = 0; i < objects.length; i++) {
            const object = objects[i];
            let exceptClear = false;

            if (isExcept) {
                for (let j = 0; j < this.exceptClearTarget.length; j++) {
                    if ((object.tag || "").includes(this.exceptClearTarget[j])) {
                        exceptClear = true;
                    }
                }
            }

            if (isClearPage) {
                for (let j = 0; j < this.exceptClearTargetAtAllClear.length; j++) {
                    if ((object.tag || "").includes(this.exceptClearTargetAtAllClear[j])) {
                        exceptClear = true;
                    }
                }
            }

            if (!exceptClear) {
                this.canvas.remove(object);
            }
        }

        this.canvas.renderAll();

        this.addHistory();
    }

    clearExcept() {
        let objects = this.canvas.getObjects();

        for (let i = 0; i < objects.length; i++) {
            const object = objects[i];
            for (let j = 0; j < this.exceptClearTarget.length; j++) {
                if ((object.tag || "").includes(this.exceptClearTarget[j])) {
                    console.log("clear::", object);
                    this.canvas.remove(object);
                }
            }
        }

        this.canvas.renderAll();
    }

    //#region 紀錄/存讀檔

    /**
     * 新增操作紀錄
     */
    addHistory() {
        this.history.push(this.getSave());
        this.tempHistory = [];
    }

    /**
     * 清除操作紀錄
     */
    clearHistory() {
        this.history = [];
        this.tempHistory = [];
    }

    // 還原
    undo() {
        if (this.history.length == 1) return;

        this.tempHistory.push(this.history.pop());

        this.loadSave(this.history[this.history.length - 1]);
    }

    // 取消還原
    redo() {
        if (this.tempHistory.length == 0) return;

        let history = this.tempHistory.pop();

        this.loadSave(history);

        this.history.push(history);
    }

    /**
     * 取得頁面資料
     */
    getSave() {
        let save = this.canvas.toObject(this.proxy.extraAttribute);

        for (let i = 0; i < this.recordIgnoreList.length; i++) {
            save.objects = save.objects.filter(object => {
                if (object.tag) {
                    return !object.tag.includes(this.recordIgnoreList[i])
                } else {
                    return !object.tag
                }
            })
        }

        return JSON.stringify(save);
    }

    /**
     * 載入存檔至頁面
     * @param {JSON} save
     */
    loadSave(save) {
        const self = this;
        if (save) {
            this.isLoading = true;

            try {
                this.canvas.loadFromJSON(save, () => {
                    self.canvas.renderAll.bind(self.canvas);
                    self.isLoading = false;
                    console.log(save)
                    setTimeout(() => {
                        if (typeof self.onFinishLoadSave == "function") {
                            const callback = self.onFinishLoadSave;
                            self.onFinishLoadSave = null;
                            callback();
                        }
                    })
                }, (o, object) => {
                    if (object.toolType) {
                        self.recoverEvent(object);
                    }
                });
            } catch (err) {
                console.error("err: ", err);
            }

        }
    }

    //#endregion

    //#region 取得物件

    /**
     * 取得相同類型的物件by tag
     * @param {string} tag
     */
    getObjects(tag) {
        return this.canvas.getObjects().filter((object) => {
            return (object.tag || "").indexOf(tag) === 0;
        });
    }

    /**
     * 取得物件by tag
     * @param {string} tag
     */
    getObject(tag) {
        return this.canvas.getObjects().find((object) => {
            return (object.tag || "") == tag;
        });
    }

    //#endregion

    /**
     * 更新層級
     */
    updateZorder() {
        let orderList = [
            DEFINE.TAG.COMPASS_LEFT,
            DEFINE.TAG.COMPASS_RIGHT,
            DEFINE.TAG.COMPASS_HEAD,
            DEFINE.TAG.COMPASS_CENTER,
            DEFINE.TAG.COMPASS_DELETE,
            DEFINE.TAG.COMPASS_FLIP,
            DEFINE.TAG.COMPASS_HORIZONTAL,
            DEFINE.TAG.COMPASS_ROTATOR,
        ];

        orderList.forEach(tag => {
            this.getObjects(tag).forEach(object => {
                object.bringToFront();
            })
        })

        this.canvas.renderAll();
    }

    getStampImgUrl() {
        const painterProxy = this.proxy;

        return painterProxy.getStampImg()
    }
}